import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
  * {
    padding: 0;
    margin: 0;
    font-family: Barlow Semi Condensed;
  }
`;
